<template>
  <div class="topicTwo">
    <canvas width="500" height="500" ref="singleChoose" style="width:100%;"></canvas>
    <div class="button">
      <div class="button-item" v-for="(item,index) in selectArr" :key="index" @click.stop="confirmAns(item)">
        {{item}}
      </div>
    </div>
  </div>
</template>

<script>
import Island from '../lib/island';

export default {
  name: 'topicTwo',
  props: {
    question: {
      type: Object,
      default: null,
    },
    reload: {
      type: Number,
    },
  },
  computed: {},
  watch: {
    reload() {
      this.initZT();
    },
    question(val) {
      if (val) {
        this.initZT();
      }
    },
    answer(val) {
      if (val) {
        this.initZT();
      }
    },
  },
  data() {
    return {
      selectArr: this.question.selector.split('||||'), // 选择选项
    };
  },
  created() {},
  mounted() {
    this.initZT();
  },
  methods: {
    initZT() {
      const { Practice } = Island;
      // eslint-disable-next-line no-new
      if (this.two) {
        this.two.off();
      }
      this.two = new Practice({
        $el: this.$refs.singleChoose, // canvas对象
        width: 500, // canvas宽度
        type: 2, // 0 执行题，1 判断题, 2 单选题，3 其他类型
        content: this.question.ask_desc, // 内容
      });
      this.selectArr = this.question.selector.split('||||');
    },
    // 获取答案正确与否
    confirmAns(item) {
      const answer = {
        desc: '', // 答案结果
        data: item, // 学生的答案
      };
      if (item === this.question.answer) {
        answer.desc = '正确';
        this.$emit('getResult_single', answer);
      } else {
        answer.desc = '错误';
        this.$emit('getResult_single', answer);
      }
    },
  },
};
</script>
<style scoped lang="scss">
  .topicTwo{
    width: 100%;
    height:100%;
    margin:auto;
    text-align:center;
    .answers{
      width:halvePx(670);
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0 auto;
      margin-top:halvePx(86);
      img{
        display:inline-block;
        width:halvePx(44);
        height:halvePx(60);
      }
      .answers-choose{
        height:auto;
        .choose-item{
          width:halvePx(540);
          height:halvePx(100);
          background:rgba(250,229,179,1);
          border:halvePx(2) solid rgba(196, 178, 135, 1);
          border-radius:halvePx(50);
          margin:auto;
          font-size:halvePx(30);
          font-family:PingFang-SC-Regular;
          font-weight:400;
          color:rgba(51,51,51,1);
          line-height:halvePx(100);
          text-align: center;
          margin:halvePx(20);
        }
      }
    }
    .button{
      width:100%;
      display:flex;
      align-items: center;
      justify-content: center;
      .button-item{
        min-width:halvePx(150);
        max-height:halvePx(100);
        line-height: halvePx(100);
        text-align: center;
        background:rgba(250,229,179,1);
        border:halvePx(2) solid rgba(196, 178, 135, 1);
        border-radius:halvePx(50);
        margin:halvePx(20);
        font-size:halvePx(30);
        font-family:PingFang-SC-Regular;
        font-weight:400;
        color:rgba(51,51,51,1);
      }
    }
  }
</style>
